<template lang="">
    <div>
        
    </div>
</template>
<script>
export default {
    data(){
        return {
            nama: "ahmad juma"
        }
    },
    methods:{
        testing(){
            //alert('test')
            let token = this.$route.query.token
            console.log(`token ${token}`);
            let formData = {
                token : token
            }
            this.$http.post('/api/sso/cross-client', formData)
			.then((resp) => {
                this.error = ''
				var user = resp.data.data;
				// console.log(resp)

				this.$http.defaults.headers.common['Authorization'] = "Bearer " + user.token;
				//user.name = this.form.username

				// const companyDetails = {
				//   company : companyName,
				//   companyLogo : companyLogo
				// }

				this.$store.dispatch('setUser', user);
            })
            .then(async () => {
				// let modules = await this.getModules();
				await this.loadFilterOptions();
				//NAVIGATION WILL BE HANDLED INSIDE LOADFILTER OPTIONS

				// console.log(modules ? 'Modules Successfully Loaded' : 'Modules Has Failed To Load');
			})
            .catch((error) => {
                console.log(error);
				this.$swal.fire({
					title : "Error!",
					icon : "error",
					type : "error",
					text : error.response.data.message
				})

                this.$router.push({name : 'Login'})

            })
        }
    },
    created(){
        this.testing()
    },
    computed:{
        token(){
            return this.$route.query.token
        }
    }
}
</script>
<style lang="">
    
</style>